// LocalStorage-backed draft store for the in-progress booking form.
// Cleared automatically when the visitor submits (Stripe redirect / PayPal capture / reservation confirm).
const KEY = "rx_booking_draft";

export function saveDraft(draft) {
  if (!draft?.vertical || !draft?.lookup_key) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...draft, ts: Date.now() }));
  } catch {
    // ignore
  }
}

export function getDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    // Auto-expire after 3 days
    if (d?.ts && Date.now() - d.ts > 3 * 24 * 3600 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return d;
  } catch {
    return null;
  }
}

export function clearDraft() {
  try { localStorage.removeItem(KEY); } catch {}
}
